import { render, staticRenderFns } from "./FamiliesChart.vue?vue&type=template&id=cdbd877c"
import script from "./FamiliesChart.vue?vue&type=script&lang=js"
export * from "./FamiliesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports